import userApi from "../../../src/api/user/userApi"

const sendClickData = (userId: string) => {
  window.dataLayer = window.dataLayer || ([] as unknown[])
  window.dataLayer.push({ event: "mount_quick", user_id: userId })
}

const sendMountQuickSelect = async () => {
  // ユーザIDを取得し、送信する(未ログイン時は空文字)
  const result = await userApi.accountInfo()
  const userId = result ? result.id : ""
  sendClickData(userId)
}

export default sendMountQuickSelect
